import React from 'react';
import { introScreenNames, pbpCardTypes } from './Models';

export function calculateSize(srcWidth, srcHeight, maxWidth, maxHeight) {
  var ratio = Math.max(maxWidth / srcWidth, maxHeight / srcHeight);

  return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export function getNavbarHeight() {
  const navbarContainer = document.getElementsByClassName('navbar-container')[0];
  if (!navbarContainer) {
    return null;
  }
  const exhibitMenuContainer = document.getElementsByClassName('exhibit-menu-container')[0];
  if (!exhibitMenuContainer) {
    return null;
  }
  return navbarContainer.getBoundingClientRect().height + exhibitMenuContainer.getBoundingClientRect().height;
}

export function getViewportDimensions() {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };
}

export function getImageFilepath(filename, maxSize = -1) {
  var sizes = [64, 128, 256, 512, 1024, 2048];
  if(maxSize <= 0){
    maxSize = Math.max(window.screen.width, window.screen.height) * window.devicePixelRatio;
  }
  var size = closest(sizes, maxSize);
  if (size && size > 0 && size < sizes[sizes.length - 1]) {
    var sizeString =  '-' + size + 'x' + size;
    var formatted = filename.substring(0, filename.lastIndexOf(".")) + sizeString + filename.substring(filename.lastIndexOf("."));
    if(formatted){
      return formatted;
    } else {
      return filename;
    }
  } else {
    return filename;
  }
}

function closest(arr, val) {
  return Math.max.apply(
    null,
    arr.filter(function (v) {
      return v <= val;
    })
  );
}

export function keepSpaceTogether(inputString, together) {
  const brokenArray = inputString.split(together);
  if (brokenArray.length > 1) {
    const togetherArray = together.split(' ');
    let newTogether = togetherArray[0];
    for (let i = 1; i < togetherArray.length; i++) {
      newTogether += '\xa0' + togetherArray[i]; // non-breakable space
    }
    let outputString = brokenArray[0];
    for (let i = 1; i < brokenArray.length; i++) {
      outputString += newTogether + brokenArray[i];
    }
    return outputString;
  } else {
    return inputString;
  }
}

export function formatParagraphs(input){
  var paragraphs = input.split(/\r?\n/);
  if(paragraphs && paragraphs.length > 1){
    var pars = [];
    for(var i = 0; i<paragraphs.length; i++){
      var text = paragraphs[i];
      if(text && text.length > 0){
        pars.push(<div key={i} className="formatted-paragraph">{paragraphs[i]}</div>);
      }
    }
    return (
      <div className="formatted-paragraph-holder">
        {pars}
      </div>
    );
  } else {
    return input;
  }
}

export const getStoryIndex = (storyId, cmsData, history) => {
  if(cmsData && cmsData.AllStories){
    var story = cmsData.AllStories[0];
    for(var i = 0; i<cmsData.AllStories.length; i++){
      var refStory = cmsData.AllStories[i];
      if(storyId && refStory.Menu.Path && getTrimmedURL(storyId) === getTrimmedURL(refStory.Menu.Path)){
          return i;
      }
    }
    if(story && story.Menu && story.Menu.Path){
      history.push(`/${cmsData.Path.Text}/${story.Menu.Path}`);
      return 0;
    } else {
      return -1;
    }
  } else {
    return -1;
  }
}

export const getPBPData = (slide, cmsData, array, history) => {
  var defaul = new PBPComponent(0, cmsData.Introduction.Key, cmsData.Introduction.Menu, pbpCardTypes.INTRODUCTION, false);
  for(var i = 0; i<array.length; i++){
    var item = array[i];
    if(slide && item && item.Menu && item.Menu.Path && getTrimmedURL(slide) === getTrimmedURL(item.Menu.Path)){
      return item;
    }
  }
  history.push(`/${cmsData.Path.Text}/${defaul.Menu.Path}`);
  return defaul;
}

export const getPBPArray = (cmsData) => {
  var arr = [];
  var index = 0;
  if(cmsData){
    if(cmsData.Introduction && cmsData.Introduction.Menu && cmsData.Introduction.Menu.Path){
      arr.push(new PBPComponent(index, cmsData.Introduction.Key, cmsData.Introduction.Menu, pbpCardTypes.INTRODUCTION, false));
      index++;
    }
    if(cmsData.Pulse && cmsData.Pulse.Menu && cmsData.Pulse.Menu.Path){
      arr.push(new PBPComponent(index, cmsData.Pulse.Key, cmsData.Pulse.Menu, pbpCardTypes.PULSE, false));
      index++;
    }
    if(cmsData.NetworkMilestones && cmsData.NetworkMilestones.Menu && cmsData.NetworkMilestones.Menu.Path){
      arr.push(new PBPComponent(index, cmsData.NetworkMilestones.Key, cmsData.NetworkMilestones.Menu, pbpCardTypes.TIMELINE, true));
      index++;
    }
    if(cmsData.Carousel && cmsData.Carousel.Menu && cmsData.Carousel.Menu.Path){
      arr.push(new PBPComponent(index, cmsData.Carousel.Key, cmsData.Carousel.Menu, pbpCardTypes.CAROUSEL, true));
      index++;
    }
  }
  return arr;
}

class PBPComponent {
  
  Index = -1;
  Key = -1;
  Menu = null;
  Type = '';
  LightBg = false;
  constructor(index, key, menu, type, lightBg){
    this.Index = index;
    this.Key = key;
    this.Menu = menu;
    this.Type = type;
    this.LightBg = lightBg;
  }
}

export const getBBFIndex = (pillarId, cmsData, history) => {
  if(cmsData && cmsData.Pillars){
    for(var i = 0; i<cmsData.Pillars.length; i++){
      var pillar = cmsData.Pillars[i];
      if(pillar && pillar.Menu && pillar.Menu.Path &&
        getTrimmedURL(pillar.Menu.Path) === getTrimmedURL(pillarId)){
            return i;
      }
    }
    if(cmsData.Pillars[0] && cmsData.Pillars[0].Menu && cmsData.Pillars[0].Menu.Path){
      history.push(`/${cmsData.Path.Text}/${cmsData.Pillars[0].Menu.Path}`);  
    } else {
      return -1;
    }
  }
  return -1;
};

export const getVBNIndex = (sectionId, cmsData, history) => {
  if(cmsData && cmsData.Sections){
    for(var i = 0; i<cmsData.Sections.length; i++){
      var section = cmsData.Sections[i];
      if(section && section.Menu && section.Menu.Path &&
        getTrimmedURL(section.Menu.Path) === getTrimmedURL(sectionId)){
            return i;
      }
    }
    if(cmsData.Sections[0] && cmsData.Sections[0].Menu && cmsData.Sections[0].Menu.Path){
      history.push(`/${cmsData.Path.Text}/${cmsData.Sections[0].Menu.Path}`);  
    } else {
      return -1;
    }
  }
  return -1;
};

export const getIntroductionIndex = (introductionId, globalData, cmsData, loaded, history) => {
  if(introductionId && globalData){
    if(globalData.Loading && globalData.Loading.Menu && globalData.Loading.Menu.Path &&
      getTrimmedURL(globalData.Loading.Menu.Path) === getTrimmedURL(introductionId)){
        return introScreenNames.LOADING;
    } else if(globalData.Introduction && globalData.Introduction.Menu && globalData.Introduction.Menu.Path &&
      getTrimmedURL(globalData.Introduction.Menu.Path) === getTrimmedURL(introductionId)){
        return introScreenNames.ANIMATION;
    } else if(globalData.Onboarding){ 
      if(globalData.Onboarding.Introduction && globalData.Onboarding.Introduction.Menu && globalData.Onboarding.Introduction.Menu.Path &&
        getTrimmedURL(globalData.Onboarding.Introduction.Menu.Path) === getTrimmedURL(introductionId)){
          return introScreenNames.TEXT_SCREEN;
      } else if(globalData.Onboarding.Menu && globalData.Onboarding.Menu.Menu && globalData.Onboarding.Menu.Menu.Path &&
        getTrimmedURL(globalData.Onboarding.Menu.Menu.Path) === getTrimmedURL(introductionId)){
          return introScreenNames.MENU_EXHIBITS;
      } else if(globalData.Onboarding.FinalSlide && globalData.Onboarding.FinalSlide.Menu && globalData.Onboarding.FinalSlide.Menu.Path &&
        getTrimmedURL(globalData.Onboarding.FinalSlide.Menu.Path) === getTrimmedURL(introductionId)){
          return introScreenNames.POST_STORIES;
      }
    }
  }
  if(introductionId && cmsData){
    if(cmsData.Stories){
      for(var i = 0; i<cmsData.Stories.length; i++){
        var story = cmsData.Stories[i];
        if(story && story.Menu && story.Menu.Path){
          if(getTrimmedURL(story.Menu.Path) === getTrimmedURL(introductionId)){
            return introScreenNames.STORY;
          }
        }
      }
    }
  }
  history.push(`/${globalData.Path.Text}/${loaded? globalData.Introduction.Menu.Path : globalData.Loading.Menu.Path}`);
  return loaded ? introScreenNames.ANIMATION : introScreenNames.LOADING;
};

export function getTrimmedURL(val){
  //Trim white space from beginning and end of URL's.
  //Make lowercase.
  var str = val;
  if(str){
    str = str.trim().toLowerCase();
  }
  return str;
};

export function parseResults(options, results) {
  var formattedData = [];
  var totalVotes = 0;
  if(options){
    for(var i = 0; i<options.length; i++){
      var option = options[i];
      var result = results ? results.find(e => e.answerId === option.Key): null;
      formattedData.push(
        { 
          key: option.Key, 
          votes: result ? result.votes : 0,
        }
      );
      totalVotes += (result ? result.votes : 0);
    }
  }
  var percentages = [];
  if(formattedData && formattedData.length > 0){
    var totalPercent = 100;
    for(var i = formattedData.length - 1; i>=0; i--){
      var fD = formattedData[i];
      var rawPercent = Math.floor((totalVotes > 0 ? (fD.votes/totalVotes) : (1/formattedData.length))*100);
      var percent = i > 0 ? rawPercent : totalPercent;
      percentages.push(
        {
          key: fD.key,
          percent: percent,
        }
      );
      totalPercent -= rawPercent;
    }
  }
  return percentages;
};

export function getImagesCSV(basePath, urls){
  if(basePath && urls){
    console.log(urls);
    for(var i = 0; i<urls.length; i++){
      var url = basePath + urls[i];
      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => response.json())
        .then(cmsData => {
          console.log(cmsData);
          formatCSV(url, cmsData);
        });
    }
  }
}

export function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if(result && result.length >= 3){
    return `rgba(${parseInt(result[1], 16)}, ${result[2], 16}, ${result[3], 16}, ${alpha && alpha > 0 ? alpha : 1})`
  }
  return 'rgba(0,0,0,1)';
}

function formatCSV(section, data) {
  var list = "";
  if(data && data.length > 0){
    for(var i = 0; i<data.length; i++){
      var line = data[i];
      if(line.FileName){
        var filename = "https://extranet.cortinaproductions.com:8080/Verizon-Digital-Museum/Files/"+line.FileName+"\t"+line.OwnerRecord;
        list+=filename+"\r";
      }
    }
  }
  console.log(section);
  console.log(list);
}

export const getPBPVideoSlides = (data) => {
  const s = [];
  if (data && data.InitSlide) {
    s.push(data.InitSlide);
  }
  if (data && data.Videos) {
    data.Videos.forEach(e => s.push(e));
  }
  return s;
}

export const getBackground = (data) => {
  const viewport = getViewportDimensions();
  if (viewport.width <= 767) {
    if (data.BackgroundMobile && data.BackgroundMobile.Image) {
      return data.BackgroundMobile;
    } else if (data.Background) {
      return data.Background;
    } else {
      return null;
    }
  } else {
    if (data.Background) {
      return data.Background;
    } else {
      return null;
    }
  }
}

export const getPodcastImage = (data) => {
  const viewport = getViewportDimensions();
  if (viewport.width <= 767) {
    if (data.PodcastImageMobile && data.PodcastImageMobile.Image) {
      return data.PodcastImageMobile;
    } else if (data.PodcastImage) {
      return data.PodcastImage;
    } else {
      return null;
    }
  } else {
    if (data.PodcastImage) {
      return data.PodcastImage;
    } else {
      return null;
    }
  }
}
